module.exports = __webpack_public_path__ + "img/fi-rr-time-past.535f69c1.svg";